/* Copyright (c) 2023 TORITI */

import axios from 'axios';
import { apiUrl } from '../config';

const getQueryString = (parameters) => {
  let qs = '';
  if (parameters) {
    Object.keys(parameters).forEach((key) => {
      const value = parameters[key];
      qs += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
    });
    return `?${qs}`;
  }
  return '';
};

function send({ method = 'get', path, data = null, query = null, headers = {}, newUrl, disableAuth }) {
  return new Promise((resolve) => {
    let url = `${apiUrl}${path}${getQueryString(query)}`;
    if (newUrl) {
      url = `${newUrl}${getQueryString(query)}`;
    }

    const token = window.localStorage.getItem('accessToken');
    if (!disableAuth && token) {
      headers.authorization = `Bearer ${token}`;
    }
    axios({
      method,
      url,
      data,
      headers
    })
      .then((result) => {
        // Handle HTTP 204 No Content responses (successful delete operations)
        if (result.status === 204) {
          return resolve({ success: true, statusCode: 204, message: 'Operation completed successfully' });
        }
        
        const data = result?.data || {};
        return resolve(data);
      })
      .catch((error) => {
        // Add comprehensive error logging
        console.error('API Request Failed:', {
          url,
          method,
          error: error.message,
          response: error.response?.data,
          status: error.response?.status,
          timestamp: new Date().toISOString()
        });

        const { response = {} } = error;
        const result = response.data ? response.data : null;

        if (!result) {
          resolve({ statusCode: 404, message: 'Network error or server unavailable' });
        } else {
          const { statusCode, message: data, error } = result;
          // Nếu server trả về JSON trên thì cũng redirect ra ngoài login.
          // Đây là trường hợp user đang sử dụng mà bị khóa"
          if (statusCode === 401 || statusCode === 505) {
            console.warn('Authentication failed, redirecting to login:', { statusCode, data });
            // message.warn(data || <FormattedMessage id="something_wrong" />)
            setTimeout(() => {
              window.localStorage.clear();
              window.location.href = '/';
            }, 1000);
          } else if (
            (statusCode === 401 && data === 'Unauthorized') ||
            (statusCode === 403 && data === 'InvalidToken') ||
            (statusCode === 599 && error === 'MAINTAIN_ALL')
          ) {
            console.warn('Token invalid or maintenance mode, redirecting:', { statusCode, data, error });
            window.localStorage.clear();
            window.location.href = '/';
          } else {
            return resolve(result);
          }
        }
      });
  });
}

const Request = {
  send
};

export default Request;
